module.exports = __webpack_public_path__ + "media/images/cover-4-a901d1387aaba3c0ae1f05ab0437cb30.jpg";